import { render, staticRenderFns } from "./BaseChatMessage.vue?vue&type=template&id=2b28f512&"
import script from "./BaseChatMessage.vue?vue&type=script&lang=ts&"
export * from "./BaseChatMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports